export const productAccessoryFields = ['productReferences', 'url', 'name'];
